export function formatPrice(amount) {
  if (!amount) return ''
  if (typeof amount === 'number') {
    return amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  }
  const reais = parseInt(amount.reais) || 0
  const centavos = parseInt(amount.centavos) || 0
  const value = reais + centavos / 100
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
